import Header from "@/components/sections/Header";
import Hero from "@/components/sections/Hero";
import AboutSection from "@/components/sections/AboutSection";
import BusinessActivities from "@/components/sections/BusinessActivities";
import Services from "@/components/sections/Services";
import Footer from "@/components/sections/Footer";

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <BusinessActivities />
        <Services />
      </main>
      <Footer />
    </>
  );
}
